import { useField } from "formik";
import { LengthSelector } from "./LengthSelector";
import { InputRadio } from "@components-common/forms";
import { SpaceFunctionSelect } from "./SpaceFunctionSelect";
import { Room } from "./building-layout.types";
import { Corridor } from "./Corridor";

export const RoomsTable = ({ id, spaceFuncOptions }: any) => {
  return (
    <div className="w-100 overflow-auto">
      <table>
        <thead>
          <tr>
            <th className={"align-middle pe-2"}>Room No.</th>
            <th className={"align-middle pe-2"}>
              Room Space function <text style={{ color: "red" }}> *</text>
            </th>
            <th className={"align-middle px-2"}>
              Length <text style={{ color: "red" }}> *</text>
            </th>
            <th className={"align-middle"}>
              Variable length <text style={{ color: "red" }}> *</text>
            </th>
          </tr>
        </thead>
        <RowLines rowId="rowFirst" spaceFunctionOptions={spaceFuncOptions} />
        <Corridor />
        <RowLines rowId="rowSecond" spaceFunctionOptions={spaceFuncOptions} />
      </table>
    </div>
  );
};

const RowLines = ({
  rowId,
  spaceFunctionOptions,
}: {
  rowId: string;
  spaceFunctionOptions: any[];
}) => {
  const [field, meta, helpers] = useField(rowId);
  return field.value.rooms.map((x: any) => (
    <LengthSelectorRowLine
      key={x.id}
      rowNo={rowId}
      room={{ ...x }}
      spaceFunctionOptions={spaceFunctionOptions}
    />
  ));
};

export const LengthSelectorRowLine = (props: {
  room: Room;
  rowNo: string;
  spaceFunctionOptions: any;
}) => {
  const { rowNo, spaceFunctionOptions } = props;
  const { id, label, length } = props.room;
  const [fieldRow, metaRow, helpersRow] = useField(`${rowNo}.rooms`);
  const [field, meta, helpers] = useField(`${rowNo}.${id}.isVariableLength`);

  const removePreviousVariableLength = (id: string) => {
    if (field.value !== true || field.value !== "true") {
      helpersRow.setValue(
        fieldRow.value.map((x: Room) => {
          if (x.id === id) return { ...x, isVariableLength: true };

          return { ...x, isVariableLength: false };
        })
      );
    }
  };

  const result = (
    <tr key={id}>
      <td className={"align-middle py-2"}>{label}</td>
      <td className={"d-flex py-2"}>
        <SpaceFunctionSelect
          rowNo={rowNo}
          options={spaceFunctionOptions}
          id={`${rowNo}.${id}.spaceFunctionId`}
        />
      </td>
      <td className={"align-middle py-2"}>
        <LengthSelector length={length} rowNo={`${rowNo}`} id={props.room.id} />
      </td>
      <td className={"align-middle py-2"}>
        <InputRadio
          fieldId={`${rowNo}.${id}.isVariableLength`}
          name={`${rowNo}`}
          checked={field.value === true}
          value={true}
          id={`${rowNo}.${id}.isVariableLengths`}
          inline={true}
          elementClass="ms-2"
          showLabel={false}
          label={""}
          onClick={(e: any) => {
            removePreviousVariableLength(id);
          }}
        />
      </td>
    </tr>
  );
  return result as any;
};
